import {
  IconArrowRight,
  IconBookmark,
  IconBrandFacebook,
  IconBrandWhatsapp,
  IconCalendar,
  IconChartLine,
  IconFile,
  IconFolder,
  IconFolderOpen,
  IconHeadset,
  IconMail,
  IconMessage,
  IconPhone,
  IconRobot,
  IconUsersGroup,
} from '@tabler/icons-react';

export const marketingChannelsOptions = [
  { label: 'Email', value: 'email' },
  { label: 'Facebook Ad', value: 'facebookAd' },
  { label: 'SMS/Text Message', value: 'sms' },
  { label: 'Viber Message', value: 'viber' },
  { label: 'WhatsApp Message', value: 'whatsApp' },
  { label: 'Blog Post', value: 'blogPost' },
  { label: 'AI Chat', value: 'chat' },
  { label: 'Document', value: 'document' },
];

export const typeOptionsByChannel = {
  folder: [],
  blogPost: [],
  chat: [],
  document: [],
  email: [
    { label: 'Newsletter', value: 'newsletter' },
    { label: 'Thank You for Subscription', value: 'thankYouForSubscription' },
    { label: 'Thank You for Your Purchase', value: 'thankYouForYourPurchase' },
    { label: 'Abandoned Browse', value: 'abandonedBrowse' },
    { label: 'Abandoned Basket', value: 'abandonedBasket' },
  ],
  facebookAd: [
    { label: 'Sales Objective', value: 'sales' },
    { label: 'Traffic Objective', value: 'traffic' },
    { label: 'Leads Objective', value: 'leads' },
    { label: 'Engagement Objective', value: 'engagement' },
    { label: 'Awareness Objective', value: 'awareness' },
    { label: 'App Promotion Objective', value: 'appPromotion' },
  ],
  viber: [
    { label: 'Newsletter', value: 'newsletter' },
    { label: 'Thank You for Subscription', value: 'thankYouForSubscription' },
    { label: 'Thank You for Your Purchase', value: 'thankYouForYourPurchase' },
    { label: 'Abandoned Browse', value: 'abandonedBrowse' },
    { label: 'Abandoned Basket', value: 'abandonedBasket' },
  ],
  sms: [
    { label: 'Newsletter', value: 'newsletter' },
    { label: 'Thank You for Subscription', value: 'thankYouForSubscription' },
    { label: 'Thank You for Your Purchase', value: 'thankYouForYourPurchase' },
    { label: 'Abandoned Browse', value: 'abandonedBrowse' },
    { label: 'Abandoned Basket', value: 'abandonedBasket' },
  ],
  whatsApp: [
    { label: 'Newsletter', value: 'newsletter' },
    { label: 'Thank You for Subscription', value: 'thankYouForSubscription' },
    { label: 'Thank You for Your Purchase', value: 'thankYouForYourPurchase' },
    { label: 'Abandoned Browse', value: 'abandonedBrowse' },
    { label: 'Abandoned Basket', value: 'abandonedBasket' },
  ],
};

export const generatedContentOptions = [
  {
    icon: IconMessage,
    title: 'AI Chat',
    description:
      'Use our tailor-mode AI to help you generate marketing strategies, images, and anything else you may need!',
    marketingChannel: 'chat',
  },
  {
    icon: IconBrandFacebook,
    title: 'Facebook ad',
    description:
      'Craft compelling Facebook ads effortlessly. Know your audience, craft headlines, and create impactful content. Get started now for maximum engagement and results.',
    marketingChannel: 'facebookAd',
  },
  {
    icon: IconMail,
    title: 'Email',
    description:
      'Elevate your email game with compelling content. Understand your audience, craft attention-grabbing subject lines, and deliver messages that resonate. Drive engagement and results with every send.',
    marketingChannel: 'email',
  },
  {
    icon: IconBookmark,
    title: 'Blog post',
    description:
      'Elevate your blog with captivating content. Master audience understanding, headline creation, and impactful writing for maximum engagement. Start crafting powerful posts today!',
    marketingChannel: 'blogPost',
  },
  {
    icon: IconPhone,
    title: 'Viber message',
    description:
      'Enhance your Viber messages with compelling content. Tailor your tone, craft attention-grabbing messages, and connect with your audience. Boost engagement and make every send count.',
    marketingChannel: 'viber',
  },
  {
    icon: IconMessage,
    title: 'Text message',
    description:
      'Transform your sms with engaging content. Tailor messages, craft attention-grabbing texts, and connect effortlessly with your audience. Boost engagement and make every sms impactful.',
    marketingChannel: 'sms',
  },
  {
    icon: IconBrandWhatsapp,
    title: 'WhatsApp',
    description:
      'Revitalize your WhatsApp messages with engaging content. Take your WhatsApp conversations to the next level with dynamic content that enhances dialogue and builds community.',
    marketingChannel: 'whatsApp',
  },
  {
    icon: IconFile,
    title: 'Document',
    description: 'Craft a unique document from scratch with custom content designed specifically for your purpose.',
    marketingChannel: 'document',
  },
];

export const agentOptions = [
  {
    icon: IconBrandFacebook,
    title: 'Facebook Agent',
    description:
      'Activate the Facebook agent to analyze your audience, generate compelling ad copy, and create high-impact content for maximum engagement and results.',
    marketingChannel: 'facebookAd',
    selected: false,
  },
  {
    icon: IconMail,
    title: 'Email Agent',
    description:
      'Deploy the Email agent to write attention-grabbing subject lines, compose persuasive messages, and craft content that resonates with your audience to drive results.',
    marketingChannel: 'email',
    selected: true,
  },
  {
    icon: IconBrandWhatsapp,
    title: 'WhatsApp Agent',
    description:
      'Engage the WhatsApp agent to generate dynamic and personal messages that enhance dialogue, build stronger community connections, and drive interaction.',
    marketingChannel: 'whatsApp',
    selected: false,
  },
  {
    icon: IconCalendar,
    title: 'Workflow Agent',
    description:
      'Launch the Workflow agent to automate and schedule your marketing tasks. Plan content calendars and create sequences across multiple channels effortlessly.',
    marketingChannel: 'workflow',
    selected: true,
  },
  {
    icon: IconHeadset,
    title: 'Customer Success Agent',
    description:
      'Enable the Customer Success agent to strengthen client relationships, provide timely support, and ensure your users achieve maximum value from your services.',
    marketingChannel: 'customerSuccess',
    selected: true,
  },
  {
    icon: IconChartLine,
    title: 'Sales Agent',
    description:
      'Activate the Sales agent to identify leads, craft persuasive outreach messages, and drive conversions through targeted communication strategies.',
    marketingChannel: 'sales',
    selected: true,
  },
  {
    icon: IconBookmark,
    title: 'Blog Agent',
    description:
      'Use the Blog agent to generate insightful articles, improve SEO rankings, and maintain a consistent and engaging content strategy.',
    marketingChannel: 'blog',
    selected: false,
  },
  {
    icon: IconUsersGroup,
    title: 'Segmentation Agent',
    description:
      'Deploy the Segmentation agent to create smart customer groups based on behavior, demographics, or engagement to personalize campaigns effectively.',
    marketingChannel: 'segmentation',
    selected: true,
  },
  {
    icon: IconMessage,
    title: 'SMS Agent',
    description: `Activate the SMS agent to send concise, high-impact messages directly to users' phones, ideal for time-sensitive offers and updates.`,
    marketingChannel: 'sms',
    selected: false,
  },
];

export const generatedContentSideIcons = {
  facebookAd: IconBrandFacebook,
  email: IconMail,
  blogPost: IconBookmark,
  viber: IconPhone,
  sms: IconMessage,
  whatsApp: IconBrandWhatsapp,
  folder: IconFolder,
  folderOpen: IconFolderOpen,
  chat: IconRobot,
  section: IconArrowRight,
  document: IconFile,
};

export const getPopupGenerationPrompt = (prompt, firstPart, secondPart, language) => {
  const enPrompt = `You are helping me edit a text document. \n
    The document is split in "First part" and  "Second part". \n
    Between the two parts do the following: ${prompt}. Do not mention the parts of the document. \n
    Your output must be no more than 50 words.\n
    Here is the document for context:\n\n
    First part: ${firstPart}\n\n
    Second part: ${secondPart}`;

  const promptInstructions = {
    en: enPrompt,
    el: `Με βοηθάτε να επεξεργαστώ ένα έγγραφο κειμένου. \n
    Το έγγραφο χωρίζεται σε «Μέρος πρώτο» και «Μέρος δεύτερο». \n
    Ανάμεσα στα δύο μέρη, εκτελέστε: ${prompt}. Μην αναφέρετε ορισμένα μέρη του εγγράφου. \n
    Το αποτέλεσμα δεν πρέπει να περιέχει περισσότερες από 50 λέξεις.\n
    Εδώ είναι το έγγραφο για το πλαίσιο:\n\n
    Μέρος πρώτο: ${firstPart}\n\n
    Μέρος δεύτερο: ${firstPart}`,
    id: `Anda membantu saya mengedit dokumen teks. \n
    Dokumen ini dibagi menjadi “Bagian Satu” dan “Bagian Kedua”. \n
    Di antara kedua bagian tersebut, jalankan: ${prompt}. Jangan menyebutkan bagian tertentu dari dokumen. \n
    Hasilnya tidak boleh lebih dari 50 kata.\n
    Berikut ini dokumen untuk konteksnya:\n\n
    Bagian Satu: ${firstPart}\n\n
    Bagian Kedua: ${firstPart}`,
    de: `Sie helfen mir, ein Textdokument zu bearbeiten. \n
    Das Dokument ist in „Teil Eins“ und „Teil Zwei“ unterteilt. \n
    Führen Sie zwischen den beiden Teilen Folgendes aus: ${prompt}. Erwähnen Sie bestimmte Teile des Dokuments nicht. \n
    Das Ergebnis sollte nicht mehr als 50 Wörter enthalten.\n
    Hier ist das Dokument für den Kontext:\n\n
    Erster Teil: ${firstPart}\n\n
    Zweiter Teil: ${firstPart}`,
    fr: `Vous m'aidez à modifier un document texte. \n
    Le document est divisé en « Première partie » et « Deuxième partie ». \n
    Entre les deux parties, exécutez ce qui suit : ${prompt}. Ne mentionnez pas certaines parties du document. \n
    Le résultat ne doit pas contenir plus de 50 mots.\n
    Voici le document pour le contexte :\n\n
    Première partie : ${firstPart}\n\n
    Deuxième partie : ${firstPart}`,
    it: `Mi stai aiutando a modificare un documento di testo. \n
    Il documento è suddiviso in “Parte Prima” e “Parte Seconda”. \n
    Tra le due parti eseguire quanto segue: ${prompt}. Non menzionare parti del documento. \n
    Il risultato non deve contenere più di 50 parole.\n
    Ecco il documento per il contesto:\n\n
    Prima parte: ${firstPart}\n\n
    Seconda parte: ${firstPart}`,
    es: `Me estás ayudando a editar un documento de texto. \n
    El documento se divide en "Primera Parte" y "Segunda Parte". \n
    Entre las dos partes haga lo siguiente: ${prompt}. No menciones las partes del documento. \n
    El resultado no debe tener más de 50 palabras.\n
    Aquí está el documento para contexto:\n\n
    Primera parte: ${firstPart}\n\n
    Segunda parte: ${firstPart}`,
    bg: `Помагаш ми да редактирам текстов документ.\n
    Документа е разделен на "Първа част" и "Втора част"\n
    Между двете части, изпълни това: ${prompt}. Не връщай частите на документа, а само резултата.\n
    Резултатът трябва да бъде не повече от 50 думи.\n
    Ето документа за контекст:\n\n
    Първа част: ${firstPart}\n\n
    Втора част: ${secondPart}`,
    ro: `Mă ajutați să editez un document text.\n
    Documentul este împărțit în "Prima parte" și "Partea a doua"\n
    Între cele două părți, executați acest lucru: ${prompt}. Nu returnați părțile documentului, ci doar rezultatul.\n
    Rezultatul nu trebuie să depășească 50 de cuvinte.\n
    Iată documentul de context:\n\n
    Prima parte: ${firstPart}\n\n
    Partea a doua: ${secondPart}`,
  };

  return promptInstructions[language];
};

export const getTextSelectionEditPrompt = (selectedText, command, language, selectedTone) => {
  const enSummarizePrompt = `Summarize the following text: ${selectedText}.`;
  const enShorterPrompt = `Keep the original focus and rewrite the following text to make it shorter: ${selectedText}.`;
  const enLongerPrompt = `Keep the original focus and rewrite the following text to make it longer: ${selectedText}. Do not add more than 10 tokens to the original length.`;
  const enChangeTone = `Keep it's original focus and paraphraze the following text in ${selectedTone} tone: ${selectedText}. Keep the same token count as the original text. Do not include any clarifications.`;

  const promptInstructions = {
    summarize: {
      en: enSummarizePrompt,
      el: `Να συνοψίσετε το ακόλουθο κείμενο: ${selectedText}.`,
      id: `kaslah teks berikut: ${selectedText}.`,
      de: `Fassen Sie den folgenden Text zusammen: ${selectedText}.`,
      fr: `Résumez le texte suivant : ${selectedText}.`,
      it: `Riassumi il seguente testo: ${selectedText}.`,
      es: `Resuma el siguiente texto: ${selectedText}.`,
      bg: `Направи обобщение на следния текст: ${selectedText}.`,
      ro: `Rezumă următorul text: ${selectedText}.`,
    },
    shorter: {
      en: enShorterPrompt,
      el: `Κρατήστε το αρχικό επίκεντρο και ξαναγράψτε το παρακάτω κείμενο για να το κάνετε πιο σύντομο: ${selectedText}.`,
      id: `Tetap pertahankan fokus asli dan tulis ulang teks berikut agar lebih singkat: ${selectedText}.`,
      de: `Behalten Sie den ursprünglichen Fokus bei und schreiben Sie den folgenden Text kürzer: ${selectedText}.`,
      fr: `Gardez le focus original et réécrivez le texte suivant pour le rendre plus court: ${selectedText}.`,
      it: `Mantieni il focus originale e riscrivi il testo seguente per renderlo più breve: ${selectedText}.`,
      es: `Mantén el enfoque original y reescribe el siguiente texto para hacerlo más corto: ${selectedText}.`,
      bg: `Запази оригиналния фокус и пренапиши следния текст по-кратък: ${selectedText}.`,
      ro: `Păstrează focusul original și rescrie textul următor pentru a-l face mai scurt: ${selectedText}.`,
    },
    longer: {
      en: enLongerPrompt,
      el: `Κρατήστε το αρχικό επίκεντρο και ξαναγράψτε το παρακάτω κείμενο για να το κάνετε μεγαλύτερο: ${selectedText}. Μην προσθέσετε περισσότερους από 10 χαρακτήρες στο αρχικό μήκος.`,
      id: `Tetap pertahankan fokus asli dan tulis ulang teks berikut agar lebih panjang: ${selectedText}. Jangan tambahkan lebih dari 10 token ke panjang asli.`,
      de: `Behalten Sie den ursprünglichen Fokus bei und schreiben Sie den folgenden Text länger:${selectedText}. Fügen Sie nicht mehr als 10 Token zur ursprünglichen Länge hinzu.`,
      fr: `Gardez le focus original et réécrivez le texte suivant pour le rendre plus long: ${selectedText}. N'ajoutez pas plus de 10 jetons à la longueur originale.`,
      it: `Mantieni il focus originale e riscrivi il testo seguente per renderlo più lungo: ${selectedText}. Non aggiungere più di 10 token alla lunghezza originale.`,
      es: `Mantén el enfoque original y reescribe el siguiente texto para hacerlo más largo: ${selectedText}. No agregues más de 10 tokens a la longitud original.`,
      bg: `Запази оригиналният фокус и пренапиши следния текс по-дълъг: ${selectedText}. Не добавяй повече от 10 токена към оригиналната дължина.`,
      ro: `Păstrează focusul original și rescrie textul următor pentru a-l face mai lung: ${selectedText}. Nu adăuga mai mult de 10 tokeni la lungimea originală.`,
    },
    changeTone: {
      en: enChangeTone,
      el: `Κρατήστε το αρχικό επίκεντρο και παραφράστε το παρακάτω κείμενο σε τόνο ${selectedTone}: ${selectedText}. Διατηρήστε τον ίδιο αριθμό τοκεν με το αρχικό κείμενο. Μην περιλαμβάνετε διευκρινίσεις.`,
      id: `Tetap pertahankan fokus asli dan parafrase teks berikut dengan nada ${selectedTone}: ${selectedText}. Pertahankan jumlah token yang sama dengan teks asli. Jangan sertakan klarifikasi apapun.`,
      de: `Behalten Sie den ursprünglichen Fokus bei und paraphrasieren Sie den folgenden Text im ${selectedTone} Ton: ${selectedText}. Behalten Sie die gleiche Token-Anzahl wie im Originaltext. Fügen Sie keine Klarstellungen hinzu.`,
      fr: `Gardez le focus original et paraphrasez le texte suivant en ton ${selectedTone}: ${selectedText}. Gardez le même nombre de jetons que le texte original. N'incluez aucune clarification.`,
      it: `Mantieni il focus originale e parafrasa il testo seguente in tono ${selectedTone}: ${selectedText}. Mantieni lo stesso numero di token del testo originale. Non includere alcuna chiarificazione.`,
      es: `Mantén el enfoque original y parafrasea el siguiente texto en un tono ${selectedTone}: ${selectedText}.  Mantén la misma cantidad de tokens que el texto original. No incluyas ninguna aclaración.`,
      bg: `Пренапиши следния текст, така че да звучи с ${selectedTone} тон: ${selectedText}. Запази същия брой токени като оригиналния текст. Не добавяй пояснения.`,
      ro: `Păstrează focusul original și parafrazează textul următor în tonul ${selectedTone}: ${selectedText}. Păstrează același număr de tokenuri ca în textul original. Nu include clarificări.`,
    },
  };

  return promptInstructions[command][language];
};
